import * as React from 'react';
import * as fp from "lodash/fp";
import WhatsMyTireSize from 'modules/cars/rating/tires/views/WhatsMyTireSize';
import LayoutAware from 'modules/cars/rating/tires/utils/LayoutAware';
import connectToStorage from 'modules/utils/connectToStorage';
import noData from 'modules/utilities/noData';

class WhatsMySize extends React.Component<any, any> {
    state = {
        isOpen: false
    };

    onClick = () => {
        this.setState({isOpen: true})
    };

    onHide = () => {
        this.setState({isOpen: false})
    };

    render() {
        return (
            <LayoutAware>
                {({isMobile}) => (
                    <WhatsMyTireSize
                        {...this.props}
                        onClick={this.onClick}
                        onHide={this.onHide}
                        isOpen={this.state.isOpen}
                        align={isMobile ? 'center' : 'left'}
                    />
                )}
            </LayoutAware>
        );
    }
}
export default fp.flowRight(
    connectToStorage('previouslySelectedTireSize', false),
    noData( ({previouslySelectedTireSize}) => previouslySelectedTireSize, fp.F )
)(WhatsMySize);



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/tires/WhatsMyTireSize.tsx